import type {ContactMap} from 'src/types/contacts';
import type {Action} from 'src/action-creators/contacts';
import type {MessagesAction} from 'src/action-creators/messages';
import type {ThreadListAction} from 'src/action-creators/thread-lists';

import omit from 'lodash/omit';
import keyBy from 'lodash/keyBy';
import merge from 'lodash/merge';

import {
  RECEIVE_MANY_CONTACTS,
  RECEIVE_CONTACT_UPDATES,
} from 'src/action-creators/contacts';
import {RECEIVE_INBOX, RECEIVE_THREAD} from 'src/action-creators/messages';
import {RECEIVE_BROADCAST} from 'src/action-creators/broadcasts';
import {RECEIVE_ONE as RECEIVE_THREAD_LIST} from 'src/action-creators/thread-lists';


export type State = {
  contacts: ContactMap;
};

const initialState = {
  contacts: {},
} as const;

export default (
  state: State = initialState,
  action: Action | MessagesAction | ThreadListAction,
): State => {
  switch (action.type) {
    case RECEIVE_MANY_CONTACTS:
      return {
        ...state,
        contacts: {
          ...state.contacts,
          ...action.payload,
        },
      };

    case RECEIVE_CONTACT_UPDATES:
      // NOTE (kyle): this store is for full contact objects only. we don't
      // allow updates to non-existent contacts.
      const updates = action.payload.filter(({id}) => state.contacts[id]);
      return {
        ...state,
        contacts: merge({}, state.contacts, keyBy(updates, 'id')),
      };

    // @ts-expect-error - TS2678 - Type '"broadcasts/receiveBroadcast"' is not comparable to type '"threads/lists/receivePage" | "threads/lists/receiveOne" | "threads/lists/receiveSome" | "threads/lists/receiveUpdated" | "threads/lists/receiveBroadcastsForThread" | ... 53 more ... | "messages/setTemplateButtonClickType"'.
    case RECEIVE_BROADCAST:
    case RECEIVE_THREAD_LIST:
    case RECEIVE_INBOX: {
      return {
        ...state,
        contacts: {
          ...state.contacts,
          ...keyBy(action.payload.contacts, 'id'),
        },
      };
    }

    case RECEIVE_THREAD: {
      const {response, beforeTime} = action.payload;
      const {contact} = response;
      if (contact) {
        return {
          ...state,
          contacts: {
            ...state.contacts,
            [contact.id]: contact,
          },
        };
      }
    }
  }

  return state;
};
